export default "__VITE_ASSET__BxPVQBrn__"